import AbnormalTable from './abnormalTable';

export default AbnormalTable;
